





























































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import TextAreaWithMode from '@/components/TextAreaWithMode.vue'
import TopicDetailComment from '@/views/Group/TopPage/NewFeed/TopicDetailComment.vue'
import ModalTopicSelectedFile from '@/components/Modal/ModalTopicSelectedFile.vue'
import { EEditMode, ETinyFileType, TopicCommentParams, TopicDetails } from '@/models'
import { sanitizeContentEditableInput } from '@/helpers/Common'

@Component({
  components: { TextAreaWithMode, TopicDetailComment, ModalTopicSelectedFile }
})
export default class TopicCommentArea extends Vue {
  @Prop() maxFileSize: any
  @Prop() title?: string
  @Prop() titleSuffix?: string
  @Prop() isCommentCmt?: boolean
  @Prop() textAreaId?: string
  @Prop() topicDetail?: TopicDetails
  newComment: TopicCommentParams = new TopicCommentParams()
  commentFileName: string = String(this.$t('common.form.not_selected'))
  eTinyFileType = ETinyFileType
  modalMess: string = ''
  valid: boolean = true

  private selecteMode = EEditMode.TEXT

  handleUpdateMode(mode: EEditMode) {
    this.selecteMode = mode
  }

  // need to handle due to contenteditable always add <br> tag
  get isCommentNotEmpty(): boolean {
    const text = this.newComment.content_comment
      .replace(/<br\s*\/?>/gi, '')
      .replace(/&nbsp;/g, '')
      .trim()
    return !!text
  }

  @Watch('newComment.attach_file')
  @Watch('newComment.content_comment')
  handleTypingStatus() {
    this.$emit(
      'status',
      !!this.newComment.content_comment.length ||
        !!this.newComment.attach_file.length
    )
  }

  handleValueComment(value: any) {
    if (value.mode === EEditMode.TEXT) {
      this.newComment.content_comment = value.text
      this.newComment.content_comment_text = value.text
    } else {
      this.newComment.content_comment = value.html
      this.newComment.content_comment_text = value.html
    }
    this.newComment.tiny_file_ids = value.fileIds
  }

  handleValidContent(valid: boolean) {
    this.valid = valid
  }

  hanldeNewComment() {
    if (
      (this.isCommentNotEmpty && this.valid) ||
      this.newComment.attach_file.length
    ) {
      let newCommentClone = { ...this.newComment }
      if (this.selecteMode === EEditMode.TEXT) {
        newCommentClone.content_comment = sanitizeContentEditableInput(
          this.newComment.content_comment
        )
        newCommentClone.content_comment_text = sanitizeContentEditableInput(
          this.newComment.content_comment_text
        )
        this.$emit('submit', newCommentClone)
      } else {
        this.$emit('submit', this.newComment)
      }
    }
  }

  clearComment() {
    this.newComment = new TopicCommentParams()
    this.commentFileName = String(this.$t('common.form.not_selected'))
  }

  /**
   * Watch files choose to handle decriptions
   */
  @Watch('newComment.attach_file')
  handleChooseFilesName() {
    let name = this.$t('common.form.multi_selected', {
      count: this.newComment.attach_file.length
    }) as string
    if (this.newComment.attach_file.length === 0) {
      name = this.$t('common.form.not_selected') as string
      this.$bvModal.hide(`modal-slelected-file-comment-area-${this.title}`)
    }
    if (this.newComment.attach_file.length === 1) {
      name = this.newComment.attach_file[0].name
    }
    this.commentFileName = name
  }

  /**
   * Handle choose multiple file
   */
  onCommentFileChange(event: any) {
    const files: File[] = event.target.files || event.dataTransfer.files
    if (!files.length) return
    if (this.newComment.attach_file.length + files.length > 30) {
      this.modalMess = this.$t('common.message.over_30_file') as string
      this.$bvModal.show(`modal-info-topic-comment-area-${this.title}`)
      return
    }
    let fileterFile: File[] = []
    let haveSomeFileOverSize: boolean = false
    files.forEach(item => {
      if (item.size > this.maxFileSize.bytes) {
        haveSomeFileOverSize = true
      } else {
        fileterFile.push(item)
      }
    })
    if (haveSomeFileOverSize) {
      this.modalMess = this.$t('common.form.some_file_over_size', {
        max: this.maxFileSize.mb
      }) as string
      this.$bvModal.show(`modal-info-topic-comment-area-${this.title}`)
    }
    this.newComment.attach_file = [
      ...this.newComment.attach_file,
      ...fileterFile
    ]
  }

  /**
   * Open modal to display all choosen files
   */
  openDisplayFiles() {
    if (this.newComment.attach_file.length)
      this.$bvModal.show(`modal-slelected-file-comment-area-${this.title}`)
  }

  /**
   * Remove file by click 'x' in files display modal
   */
  removeFileFromFilesModal(index: number) {
    this.newComment.attach_file = this.newComment.attach_file.filter(
      (item: any, i: number) => i !== index
    )
  }

  clearInputValue(event: any) {
    event.target.value = null
  }
}
